import React from 'react';
import { Modal } from 'react-bootstrap/lib';
import PropTypes from 'prop-types';
import './SlideoutSubmitSuccess.scss';
import classNames from 'classnames';
import SlideoutHeaderButton from '../Header/SlideoutHeaderButton';
const propTypes = {
  submitSuccessTitle: PropTypes.string.isRequired,
  submitSuccessDetails: PropTypes.any.isRequired,
  className: PropTypes.string,
  classNameTitle: PropTypes.string,
  classNameDetails: PropTypes.string,
  classNameAction: PropTypes.string,
  closeAction: PropTypes.func,
  actionText: PropTypes.string.isRequired,
  actionFunction: PropTypes.func.isRequired
};

const SlideoutSubmitSuccess = props => {
  const mainClass = classNames({
    'slideout-submit-success': true,
    [props.className]: !!props.className
  });

  const titleClass = classNames({
    'slideout-submit-success__title': true,
    [props.classNameTitle]: !!props.classNameTitle
  });
  const detailsClass = classNames({
    'slideout-submit-success__details': true,
    [props.classNameDetails]: !!props.classNameDetails
  });
  const actionClass = classNames({
    'slideout-submit-success__action': true,
    [props.classNameAction]: !!props.classNameAction
  });

  return (
    <div className={mainClass}>
      {props.closeAction && (
        <SlideoutHeaderButton
          buttonClass="slideout-header__button"
          iconClass="icon-cancel"
          onClick={props.closeAction}
        />
      )}
      <div className="icon-circle icon-reverse slideout-submit-success__icon">
        <i className="icon-check" />
      </div>
      <h2 className={titleClass}>{props.submitSuccessTitle}</h2>
      <div className={detailsClass}>{props.submitSuccessDetails}</div>
      <a className={actionClass} onClick={props.actionFunction}>
        {props.actionText}
      </a>
    </div>
  );
};

SlideoutSubmitSuccess.propTypes = propTypes;
export default SlideoutSubmitSuccess;
